import { EXPRESS_API } from 'configs/api/expressApi';

export const getTeamMembersForUser = async () => {
  const response = await EXPRESS_API.get('/droplr/team-members');
  return response.data;
};
